import {
    ShoppingBag,
    CalendarDays,
    IndianRupee,
    Truck,
} from "lucide-react";

import "./OrderHistoryCard.css";

function OrderHistoryCard({ orders }) {

    if (!orders || orders.length === 0) {

        return (

            <div className="customer-card">

                <h2 className="customer-card-title">

                    Order History

                </h2>

                <p className="customer-empty">

                    No orders found.

                </p>

            </div>

        );

    }

    return (

        <div className="customer-card">

            <h2 className="customer-card-title">

                Order History

            </h2>

            <div className="customer-orders-list">

                {orders.map((order) => (

                    <div
                        key={order._id}
                        className="customer-order-item"
                    >

                        <div className="customer-order-top">

                            <div>

                                <h3>

                                    {order.orderNumber}

                                </h3>

                                <p>

                                    {order.providerId?.business?.businessName ||
                                        "Provider"}

                                </p>

                            </div>

                            <span
                                className={`order-status ${order.status?.toLowerCase()}`}
                            >

                                {order.status}

                            </span>

                        </div>

                        <div className="customer-order-details">

                            <span>

                                <IndianRupee size={16} />

                                ₹{Number(order.grandTotal || 0).toLocaleString("en-IN")}

                            </span>

                            <span>

                                <ShoppingBag size={16} />

                                {order.items?.length || 0} Items

                            </span>

                            <span>

                                <CalendarDays size={16} />

                                {new Date(order.createdAt).toLocaleDateString("en-IN")}

                            </span>

                            <span>

                                <Truck size={16} />

                                {order.status}

                            </span>

                        </div>

                    </div>

                ))}

            </div>

        </div>

    );

}

export default OrderHistoryCard;